export const getCustomSEOByPage = ({ title, metaDescription, pathname, menuName, keywordsTag }: {
  pathname: string
  menuName: string
  title: string
  metaDescription: string
  keywordsTag: string
}): {
  customTitle: string
  customDescription: string
  customKeywordsTag: string
} => {
  if (pathname === '/[locale]/reservations') {
    return {
      customTitle: `${menuName} | Reservations`,
      customDescription: `Make a reservation at ${menuName}`,
      customKeywordsTag: `${menuName} reservation, ${menuName} booking, ${menuName} reserve`
    }
  }
  if (pathname === '/[locale]/maintenance') {
    return {
      customTitle: 'Site under maintenance',
      customDescription: 'Site under maintenance',
      customKeywordsTag: 'maintenance'
    }
  }
  return {
    customTitle: title,
    customDescription: metaDescription,
    customKeywordsTag: keywordsTag
  }
}
